import RMSSyncPortfolioContainer from "./RMSSyncPortfolioContainer";
import RMSSyncPortfolioStore from "./RMSSyncPortfolioStore";

export default RMSSyncPortfolioStore(RMSSyncPortfolioContainer);
